module.exports = __webpack_public_path__ + "img/sereniby.5b7274d9.png";